import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'
import { getToken } from '@/utils/cookies'
import store from '@/store'

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/',
    redirect: '/apps/list',
    hidden: true,
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/index'),
    hidden: true,
  },
  /*{
    path: '/topic',
    redirect: '/topic/list',
    component: Layout,
    meta: {
      alwaysShow: true,
      icon: 'el-icon-eleme',
    },
    children: [
      {
        path: '/topic/list',
        component: () => import('@/views/topic/list.vue'),
        name: 'topicList',
        meta: {
          title: '专题列表',
          keepAlive: false,
        },
      },
      {
        path: '/topic/detail',
        component: () => import('@/views/topic/detail.vue'),
        name: 'topicDetail',
        hidden: true,
        meta: {
          title: '专题详情',
          keepAlive: false,
        },
      },
    ],
  },*/
  {
    path: '/block',
    redirect: '/block/list',
    component: Layout,
    meta: {
      alwaysShow: true,
      icon: 'el-icon-eleme',
    },
    children: [
      {
        path: '/block/list',
        component: () => import('@/views/block/list.vue'),
        name: 'blockList',
        meta: {
          title: '区块列表',
          keepAlive: false,
        },
      },
      {
        path: '/block/detail',
        component: () => import('@/views/block/detail.vue'),
        name: 'blockDetail',
        hidden: true,
        meta: {
          title: '区块详情',
          keepAlive: false,
        },
      },
    ],
  },
  {
    path: '/deploy',
    redirect: '/deploy/list',
    component: Layout,
    meta: {
      alwaysShow: true,
      icon: 'el-icon-s-open',
    },
    children: [
      {
        path: '/deploy/list',
        component: () => import('@/views/deploy/list.vue'),
        name: 'deployList',
        meta: {
          title: '发布列表',
          keepAlive: false,
        },
      },
    ],
  },
  {
    path: '/apps',
    component: Layout,
    redirect: '/apps/list',
    meta: {
      alwaysShow: true,
      title: '应用管理',
      icon: 'el-icon-s-shop',
    },
    children: [
      {
        path: '/apps/list',
        name: 'appList',
        component: () => import('@/views/app/list.vue'),
        meta: {
          title: '应用列表',
        },
      },
      {
        path: '/apps/detail',
        name: 'appDetail',
        component: () => import('@/views/app/detailV2.vue'),
      },
      {
        path: '/apps/reviews',
        name: 'appReviewList',
        component: () => import('@/views/review/list.vue'),
        meta: {
          title: '应用审核列表',
        },
      },
      {
        path: '/comment/list',
        component: () => import('@/views/comment/list.vue'),
        name: 'commentList',
        meta: {
          title: '应用评论',
          keepAlive: false,
        },
      },
      {
        path: '/comment/detail',
        component: () => import('@/views/comment/detail.vue'),
        name: 'commentDetail',
        hidden: true,
        meta: {
          title: '评论详情',
          keepAlive: false,
        },
      },
      {
        path: '/kind/list',
        component: () => import('@/views/kind/list.vue'),
        name: 'kindList',
        meta: {
          title: '应用属性',
          keepAlive: false,
        },
      },
      {
        path: '/kind/detail',
        component: () => import('@/views/kind/detail.vue'),
        name: 'kindDetail',
        hidden: true,
        meta: {
          title: '属性详情',
          keepAlive: false,
        },
      },

      {
        path: '/apps/reviews/:id',
        name: 'appReviewDetail',
        component: () => import('@/views/review/detailV2.vue'),
      },
    ],
  },
  {
    path: '/developer',
    redirect: '/developer/list',
    component: Layout,
    meta: {
      alwaysShow: true,
      title: '开发者管理',
      icon: 'el-icon-suitcase',
    },
    children: [
      {
        path: '/developer/list',
        component: () => import('@/views/developer/list.vue'),
        name: 'developerList',
        meta: {
          title: '开发者列表',
          keepAlive: false,
        },
      },
      {
        path: '/developer/add',
        name: 'developerAdd',
        component: () => import('@/views/developer/add.vue'),
      },
      {
        path: '/developer/reviews',
        component: () => import('@/views/developer/reviewList.vue'),
        name: 'developerReviewList',
        meta: {
          title: '开发者申请列表',
          keepAlive: false,
        },
      },
      {
        path: '/developer/reviews/:id',
        name: 'developerReviewDetail',
        component: () => import('@/views/developer/reviewDetail.vue'),
      },
      {
        path: '/developer/:id',
        name: 'developerDetail',
        component: () => import('@/views/developer/detail.vue'),
      },
    ],
  },
  {
    path: '/category',
    redirect: '/category/list',
    component: Layout,
    meta: {
      alwaysShow: true,
      icon: 'el-icon-suitcase',
    },
    children: [
      {
        path: '/category/list',
        component: () => import('@/views/category/list.vue'),
        name: 'categoryList',
        meta: {
          title: '应用分类',
          keepAlive: false,
        },
      },
    ],
  },
  {
    path: '/user',
    redirect: '/user/list',
    component: Layout,
    meta: {
      alwaysShow: true,
      icon: 'el-icon-eleme',
    },
    children: [
      {
        path: '/user/list',
        component: () => import('@/views/user/list.vue'),
        name: 'userList',
        meta: {
          title: '用户列表',
          keepAlive: false,
        },
      },
    ],
  },
  {
    path: '/operate_log',
    redirect: '/operate_log/list',
    component: Layout,
    meta: {
      alwaysShow: true,
      title: '操作日志',
    },
    children: [
      {
        path: '/operate_log/list',
        component: () => import('@/views/operate_log/list.vue'),
        name: 'operateLogList',
        meta: {
          title: '日志列表',
          keepAlive: false,
        },
      },
      {
        path: '/operate_log/:id',
        component: () => import('@/views/operate_log/detail.vue'),
        name: 'operateLogDetail',
        hidden: true,
        meta: {
          title: '日志详情',
          keepAlive: false,
        },
      },
    ],
  },
  {
    path: '/notification',
    redirect: '/notification/list',
    component: Layout,
    meta: {
      alwaysShow: true,
      title: '通知列表',
    },
    children: [
      {
        path: '/notification/list',
        component: () => import('@/views/notification/list.vue'),
        name: 'notificationList',
        meta: {
          title: '通知列表',
          keepAlive: false,
        },
      },
      {
        path: '/notification/:id',
        component: () => import('@/views/notification/detail.vue'),
        name: 'notificationDetail',
        hidden: true,
        meta: {
          title: '通知详情',
          keepAlive: false,
        },
      },
    ],
  },

  // route replace
  {
    path: '*',
    component: () => import('@/views/404'),
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true,
  },
]

const createRouter = () =>
  new Router({
    scrollBehavior: () => ({
      y: 0,
    }),
    routes: constantRoutes,
  })

const router = createRouter()

router.beforeEach(async (to, from, next) => {
  if (to.name === 'login') {
    return next()
  }

  if (!getToken()) {
    next(`/login?redirect=${to.path}`)
  } else {
    try {
      await store.dispatch('user/current')
      next()
    } catch (e) {
      console.trace(e)
      next()
    }
  }
})

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset
}

export { constantRoutes as routes }

export default router
